export default __webpack_public_path__ + "static/media/twitter.8327f723.svg";